<template>
  <div id="FindCoreCreditsForm" class="card">
    <div class="card-header">
      {{ getContentItem("FindCoreCredits") }}
    </div>
    <div class="card-body">
      <form @submit.prevent="search">
        <p class="card-text">
          {{ getContentItem('FindCoreCreditsMessage') }}
        </p>
        
        <b-input-group>
          <b-form-input
            v-model="searchTerm"
            type="text"
            class="form-control"
            aria-describedby="searchTerm"
          />
          <div class="input-group-append">
            <b-button 
              variant="dark" 
              :disabled="(searchTerm === '' )" 
              type="submit" 
            >
              {{ getContentItem('goButton') }}
            </b-button>
          </div>
        </b-input-group>
      </form>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";

  export default {
    name: "FindCoreCredits",
    props: {
      documentNumber: { type: String, default: "" }
    },
    data: function() {
      return {
        searchTerm: "",
      };
    },
    computed: {
      ...mapGetters(["getContentItem"]),
    },
    created () {
      if (this.documentNumber) {
        this.searchTerm = this.documentNumber;
      }
    },
    methods: {
      search() {
        this.$router.push({ name: "CoreCredits", query: { documentNumber: this.searchTerm.trim() } });
      }
    }
  };
</script>